// Change the following hash to any other value trigger `lerna` version bumps
// hash: r$#2gndj$bfd32b435wet5

import { FileUpload } from './FileUpload';
export default FileUpload;
